import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'
import mixin from './mixins'
import VueSweetalert2 from 'vue-sweetalert2'
import VueLoading from 'vue-loading-overlay'
// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.js'

import 'sweetalert2/dist/sweetalert2.min.css'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueApexCharts from 'vue3-apexcharts'
import AuditTypeSelector from './components/AuditTypeSelector.vue'
import AuditTypeSummary from './components/AuditTypeSummary.vue'

const app = createApp(App)
app.use(store)
app.use(router)
app.use(VueSweetalert2)
app.use(VueLoading)
app.mixin(mixin)
app.use(VueApexCharts)
app.component('AuditTypeSelector', AuditTypeSelector)
app.component('AuditTypeSummary', AuditTypeSummary)

app.directive('focus', {
  mounted(el) {
    el.focus()
  }
})

app.directive('number', {
  mounted(el) {
    el.addEventListener('input', () => {
      event.target.value = event.target.value.replace(/[^0-9]/g, '')
    })
  }
})

app.directive('lowercase', {
  mounted(el) {
    el.addEventListener('input', () => {
      event.target.value = event.target.value.replace(/[^a-z]/g, '')
    })
  }
})

app.directive('uppercase', {
  mounted(el) {
    el.addEventListener('input', () => {
      event.target.value = event.target.value.replace(/[^A-Z]/g, '')
    })
  }
})

app.directive('korean', {
  mounted(el) {
    el.addEventListener('input', () => {
      event.target.value = event.target.value.replace(
        /[^ㄱ-ㅎ|ㅏ-ㅣ|가-힣]|\|/g,
        ''
      )
    })
  }
})

app.mount('#app')

// 카카오 로그인
// window.Kakao.init('5eb237caee8b8476ce1c8441f7831627')
